import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Translator } from '@sharedV11/services/translator/translator.service';
import { isBase64Image, loadImage } from '@sharedV11/utils';

@Component({
  selector: 'app-input-with-image-preview',
  templateUrl: './input-with-image-preview.component.html',
  styleUrls: ['./input-with-image-preview.component.scss'],

})
export class InputWithImagePreviewComponent implements OnInit {
  @Input() btnLabel: string = '';
  @Input() imageAlt: string = '';
  @Input() imageBase64 = '';
  @Input() imageSizeLimitOnMb: number | null = null;
  @Input() imageWrapperWith = '';
  @Input() imageWrapperHeight = '';
  @Input() isRemoveImageBtnVisible = true;
  @Input() allowFileTypes: string[] =  [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
    'image/gif',
  ];
  
  @Output() emmitImageBase64 = new EventEmitter<string>();
  @Output() onDownLoadImage = new EventEmitter<void>();
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>
  
  private selectedFile: File;
  
  public imageSizeLimitErrorMessage = '';
  public imageTypeErrorMessage = '';
  public imagePreview: string = '';
  public errorMessage: string | null = null;
  public defaultImgAlt = '';
  public isShowImage = false;

  constructor(private translatorService: Translator) { 
    this.imageSizeLimitErrorMessage = translatorService.instant('ImagenSizeErrorMessage');
    this.imageTypeErrorMessage = translatorService.instant('ImagenTipoErrorMessage');
  }

  ngOnInit(): void {
    if (this.imageBase64) {
      this.setPreviewFromParent(this.imageBase64);
    }
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement)?.files?.[0];

    if (!file) {
      this.imagePreview = '';
      this.isShowImage = false;
      return;
    };

    if (this.imageSizeLimitOnMb && file.size > this.imageSizeLimitOnMb * ( 1024 * 1024)) {
      this.errorMessage = `${this.imageSizeLimitErrorMessage} ${this.imageSizeLimitOnMb}mb`;
      this.imagePreview = '';

      return;
    }

    if (!this.allowFileTypes.includes(file.type) || !file.type.startsWith('image/')) {
      this.errorMessage = `${this.imageTypeErrorMessage} ${this.allowFileTypes?.map(imgType => `.${imgType.split('/')[1]}`).join(', ')}`;
      this.imagePreview = '';
      this.isShowImage = false;

      return;
    }
    
    this.selectedFile = file;
    this.defaultImgAlt = this.imageAlt || file?.name;
    this.errorMessage = '';

    const reader = new FileReader();

    reader.onload = () => {
      this.imagePreview = reader.result as string;
      this.isShowImage = true;
      this.emmitImageBase64.emit(reader.result as string);
    }

    reader.readAsDataURL(file);
  }

  downloadImage(input: HTMLInputElement): void {
    input.click();
    this.onDownLoadImage.emit();
  }

  removeImage(input: HTMLInputElement): void {
    this.isShowImage = false;
    this.emmitImageBase64.emit('');

    setTimeout(() => {
      input.value = '';
      this.selectedFile = null;
      this.imagePreview = '';
      this.defaultImgAlt = '';
      this.errorMessage = '';
    }, 200)
  }

  async setPreviewFromParent(base64: string): Promise<void> {
    if (!isBase64Image(base64)) return;

    const isValid = await loadImage(base64);

    if (!isValid) return;

    this.imagePreview = base64;
    this.isShowImage = true;
  }
}
